import { GenIcon } from '../helpers/IconBase.es.js';

const JumpForwardOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.21967 18.7197C4.92678 19.0126 4.92678 19.4874 5.21967 19.7803C5.51256 20.0732 5.98744 20.0732 6.28033 19.7803L13.2803 12.7803C13.5732 12.4874 13.5732 12.0126 13.2803 11.7197L6.28033 4.71967C5.98744 4.42678 5.51256 4.42678 5.21967 4.71967C4.92678 5.01256 4.92678 5.48744 5.21967 5.78033L11.6893 12.25L5.21967 18.7197ZM11.2197 18.7197C10.9268 19.0126 10.9268 19.4874 11.2197 19.7803C11.5126 20.0732 11.9874 20.0732 12.2803 19.7803L19.2803 12.7803C19.5732 12.4874 19.5732 12.0126 19.2803 11.7197L12.2803 4.71967C11.9874 4.42678 11.5126 4.42678 11.2197 4.71967C10.9268 5.01256 10.9268 5.48744 11.2197 5.78033L17.6893 12.25L11.2197 18.7197Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { JumpForwardOutlined };
